<div class="response-builder">
  <header class="response-builder-header">
    <span class="response-builder-title">Response template</span>
    <button type="button" class="link" (click)="toggleRaw()">
      {{ raw() ? 'Use builder' : 'Edit raw JSON' }}
    </button>
  </header>

  @if (raw()) {
    <textarea
      class="response-raw"
      rows="4"
      [value]="value()"
      (input)="onRawChange($any($event.target).value)"
      [placeholder]="rawPlaceholder"
      spellcheck="false"
    ></textarea>
  } @else {
    <div class="response-rows">
      @for (row of rows(); track $index; let i = $index) {
        <div class="response-row">
          <input
            class="response-key"
            type="text"
            placeholder="metadata key"
            [value]="row.key"
            (input)="setKey(i, $any($event.target).value)"
          />
          <span class="response-arrow">←</span>
          <input
            class="response-path"
            type="text"
            [placeholder]="pathPlaceholder()"
            [value]="row.path"
            (input)="setPath(i, $any($event.target).value)"
          />
          <button
            type="button"
            class="response-remove"
            (click)="removeRow(i)"
            aria-label="Remove row"
          >
            ×
          </button>
        </div>
      }
      <button type="button" class="response-add" (click)="addRow()">+ Add mapping</button>
    </div>

    <pre class="response-preview" aria-label="Generated template">{{ value() || '{}' }}</pre>
  }
</div>
